import {
  CHECKOUT_ITEM_TYPE_ACCOMMODATION_V2,
  CHECKOUT_ITEM_TYPE_BEDBANK,
  CHECKOUT_ITEM_TYPE_BOOKING_PROTECTION,
  CHECKOUT_ITEM_TYPE_BUNDLE_AND_SAVE,
  CHECKOUT_ITEM_TYPE_INSURANCE,
  CHECKOUT_ITEM_TYPE_LE_HOTEL,
  CHECKOUT_ITEM_TYPE_LUXURY_PLUS_JOINING_FEE,
  CHECKOUT_ITEM_TYPE_LUXURY_PLUS_SUBSCRIPTION,
  CHECKOUT_ITEM_TYPE_VILLA,
} from './checkout'

export const USER_CART_ADDON_TYPES = [
  CHECKOUT_ITEM_TYPE_INSURANCE,
  CHECKOUT_ITEM_TYPE_LUXURY_PLUS_JOINING_FEE,
  CHECKOUT_ITEM_TYPE_BOOKING_PROTECTION,
  CHECKOUT_ITEM_TYPE_LUXURY_PLUS_SUBSCRIPTION,
] satisfies Array<App.Checkout.AnyItemType>

export type UserCartAddonItemType = typeof USER_CART_ADDON_TYPES[number]

export const USER_CART_ACCOMMODATION_TYPES = [
  CHECKOUT_ITEM_TYPE_BEDBANK,
  CHECKOUT_ITEM_TYPE_ACCOMMODATION_V2,
  CHECKOUT_ITEM_TYPE_LE_HOTEL,
  CHECKOUT_ITEM_TYPE_BUNDLE_AND_SAVE,
  CHECKOUT_ITEM_TYPE_VILLA,
] satisfies Array<App.Checkout.AnyItemType>

export type UserCartAccommodationItemType = typeof USER_CART_ACCOMMODATION_TYPES[number]

export const NON_DUPLICABLE_ITEM_TYPES = [
  CHECKOUT_ITEM_TYPE_INSURANCE,
  CHECKOUT_ITEM_TYPE_LUXURY_PLUS_JOINING_FEE,
  CHECKOUT_ITEM_TYPE_LUXURY_PLUS_SUBSCRIPTION,
] satisfies Array<App.Checkout.AnyItemType>

export const USER_CART_PREVIEW_MAX_DAYS_TO_SHOW = 3

/**
 * Days after the check-in/travel start date becomes past before automatically
 * soft-deleting the cart item. Date-only bookings expire after that day ends.
 * Price-quote expiry does not start this timer.
 */
export const CART_AUTO_DELETE_DAYS_AFTER_EXPIRY = 1
export const CART_AUTO_DELETE_DAYS_AFTER_ADDED = 30
